var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRadius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.833 8A5.833 5.833 0 1 1 3.208 4.673a1.26 1.26 0 0 1-.925-.713A7 7 0 1 0 3.96 2.283c.368.17.64.513.713.925A5.833 5.833 0 0 1 13.833 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.43 2.75a.68.68 0 1 0 0 1.36.68.68 0 0 0 0-1.36m-1.847.68a1.846 1.846 0 1 1 3.693 0 1.846 1.846 0 0 1-3.693 0M8.096 7.417a.68.68 0 1 0 0 1.359.68.68 0 0 0 0-1.36m-1.846.68a1.846 1.846 0 1 1 3.692 0 1.846 1.846 0 0 1-3.692 0",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadius);
export default __webpack_public_path__ + "static/media/radius.918883cac2640dbf690caea168129604.svg";
export { ForwardRef as ReactComponent };